import React, { useEffect } from 'react';
import { ViewCandidate, EditProductForm, Header, JobSearch, Maincontainer, Createcontainer, AddCompany, ViewItemsContainer, AddUserContainer, ManageUsersContainer, AddSlider, UploadResume, ProductDetails, Footer, MyAccount, MyApplications, Aboutus, ContactUs, Dashboard, ConsultantCareer, CareersAtNexify, CultureNexify, Benefits, Faqs, Partners, ProductScreen, ViewCompany, CreateCompanycontainer, Process } from './components';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useStateValue } from './context/StateProvider';
import { getAllItems, getAllCompany, getSlider } from './utils/firebaseFunctions';
import { actionType } from './context/Reducer';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from './firebase.config';
import ViewJobApplication from './components/ViewJobApplication';
import Service from './components/Service';
import CloudComputing from './components/CloudComputing';
import ExperiencedProfessionals from './components/ExperiencedProfessionals';
import StudentsNewGrads from './components/StudentsNewGrads';
import ConsultantCare from './components/ConsultantCare';
import Recruiting from './components/Recruiting';
import TypicalRecruiter from './components/TypicalRecruiter';
import ScienceSales from './components/ScienceSales';
import JobSearchCareers from './components/JobSearchCareers';
import { Helmet } from 'react-helmet';
import Blogs from './components/Blogs';
import ViewBlogs from './components/viewblogs';
import SignIn from './components/SignIn';
import AdminLogin from './components/AdminLogin';
import BlogDetails from './components/BlogDetails';
import CaseStudies from './components/CaseStudies';
import ViewEnquire from './components/ViewEnquire';
import AddServices from './components/AddServices';
import ServiceDetails from './components/ServiceDetails';
import EditBlogForm from './components/EditBlogForm';
import EditService from './components/EditService';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Cookie from './components/Cookie';


function App() {
  const [{ user, Products, Company, Slider }, dispatch] = useStateValue();
  const location = useLocation(); // Get the current route
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page on route change
  }, [location]);

  const fetchProductData = async () => {
    try {
      const data = await getAllItems();
      dispatch({
        type: actionType.SET_PRODUCT,
        Products: data,
      });
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchCompanyData = async () => {
    try {
      const data = await getAllCompany();
      dispatch({
        type: actionType.SET_COMPANY,
        Company: data,
      });
    } catch (error) {
      console.error("Error fetching company:", error);
    }
  };

  const fetchSliderData = async () => {
    try {
      const data = await getSlider();
      dispatch({
        type: actionType.SET_SLIDER,
        Slider: data,
      });
    } catch (error) {
      console.error("Error fetching slider:", error);
    }
  };

  const fetchOrders = async () => {
    if (user) {
      try {
        const userRef = doc(firestore, `users/${user.uid}`);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const ordersData = userDoc.data().orders || {}; // Provide a fallback to an empty object
          const ordersArray = Object.entries(ordersData).map(([key, value]) => ({
            id: key,
            ...value,
          }));
          // Dispatch orders to global state
          dispatch({ type: actionType.SET_ORDERS, orders: ordersArray });
        } else {
          console.log("No user document found.");
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    }
  };

  const fetchConformOrders = async () => {
    if (user) {
      try {
        const userRef = doc(firestore, `users/${user.uid}`);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const ordersData = userDoc.data().conformorder || {};
          const ordersArray = Object.entries(ordersData).map(([key, value]) => ({
            id: key,
            ...value,
          }));
          console.log("Fetched conform orders:", ordersArray); // Add this line
          dispatch({ type: actionType.SET_ConformORDERS, conformorders: ordersArray });
        } else {
          console.log("No user document found.");
        }
      } catch (error) {
        console.error("Error fetching conform orders:", error);
      }
    }
  };


  useEffect(() => {
    fetchProductData();
    fetchCompanyData();
    fetchSliderData();
    if (user) {
      fetchOrders();
      fetchConformOrders();// Fetch orders when user is logged in
    }
  }, [user]);

  // List of routes where Footer should not be displayed
  const hideFooterRoutes = ['/createItem', '/addBrand', '/viewItems', '/addUser', '/manageUsers', '/addSlider', '/addBlogs', '/dashboard', '/createcompanyItem', '/addCompany', '/view-candidate', '/viewenquire', '/Addservices', '/edit-product/:productId', '/view-application'];
  // const shouldHideFooter = hideFooterRoutes.includes(location.pathname);
  const hideHeaderRoutes = ['/Signin', '/login', '/dashboard', '/createItem', '/addBrand', '/viewItems', '/addUser', '/manageUsers', '/addSlider', '/addBlogs', '/createcompanyItem', '/addCompany', '/view-candidate', '/viewenquire', '/Addservices', '/edit-product/:productId', '/view-application'];
  //const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);
  const shouldHideFooter =
    hideFooterRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/edit-product/') ||
    location.pathname.startsWith('/edit-blog') ||
    location.pathname.startsWith('/edit-service');


  const shouldHideHeader =
    hideHeaderRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/edit-product/') ||
    location.pathname.startsWith('/edit-blog') ||
    location.pathname.startsWith('/edit-service');



  return (
    <AnimatePresence onExitComplete>

      <Helmet>
        <title>Nexify InfoSystems </title>

        <meta
          name="description"
          content="At Nexify InfoSystems, we redefine consulting and staffing with cutting-edge IT solutions in Automation, AI, Data Engineering, Cloud Computing, Cybersecurity, and more. Our bespoke strategies help businesses unlock their full potential."
        />
        <meta
          name="keywords"
          content="Nexify InfoSystems, IT Consulting, Automation, Artificial Intelligence, Data Engineering, Cloud Computing, Cybersecurity, Technology Consulting, Advanced Talent Screening, Digital Transformation, Business Innovation, IT Solutions"
        />
        <meta
          name="robots"
          content={
            window.location.hostname.includes("web.app")
              ? "noindex, nofollow"
              : "index, follow"
          }
        />

        <link rel="canonical" href="https://nexifyinfosystem.com" />
      </Helmet>

      <div className='w-full h-auto flex flex-col bg-white overflow-x-hidden'>
        {!shouldHideHeader && <Header />}
        <main className='w-full overflow-hidden'>
          <Routes>
            <Route path='/*' element={<Maincontainer />} />
            <Route path='/createItem' element={<Createcontainer />} />
            <Route path='/createcompanyItem' element={<CreateCompanycontainer />} />
            <Route path='/addCompany' element={<AddCompany />} />
            <Route path='/viewItems' element={<ViewItemsContainer />} />
            <Route path='/addUser' element={<AddUserContainer />} />
            <Route path='/manageUsers' element={<ManageUsersContainer />} />
            <Route path='/addSlider' element={<AddSlider />} />
            <Route path='/product/:id' element={<ProductDetails />} />
            <Route path="/my-info" element={<MyAccount />} />
            <Route path="/my-application" element={<MyApplications />} />
            <Route path="/about" element={<Aboutus />} />
            <Route path="/process" element={<Process />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/upload-resume" element={<UploadResume />} />
            <Route path="/job-search" element={<JobSearch />} />
            <Route path="/job-search-career" element={<JobSearchCareers />} />
            <Route path="/view-candidate" element={<ViewCandidate />} />
            <Route path="/view-application" element={<ViewJobApplication />} />
            <Route path="/edit-service/:serviceId" element={<EditService />} />

            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/edit-product/:productId" element={<EditProductForm />} />
            <Route path="/edit-blog/:blogId" element={<EditBlogForm />} />
            <Route path="/service" element={<Service />} />
            <Route path="/cloudcomputing" element={<CloudComputing />} />
            <Route path="/consultantcareer" element={<ConsultantCareer />} />
            <Route path="/careers-at-nexify" element={<CareersAtNexify />} />
            <Route path="/culture-nexify" element={<CultureNexify />} />
            <Route path="/experienced-professionals" element={<ExperiencedProfessionals />} />
            <Route path="/students-new-grads" element={<StudentsNewGrads />} />
            <Route path="/consultant-care" element={<ConsultantCare />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/consulting" element={<ProductScreen />} />
            <Route path="/recruiting" element={<Recruiting />} />
            <Route path="/typical-recruiter" element={<TypicalRecruiter />} />
            <Route path="/sciencesales" element={<ScienceSales />} />
            <Route path="/addBlogs" element={<Blogs />} />
            <Route path="/Blogs" element={<ViewBlogs />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/Signin" element={<SignIn />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/viewenquire" element={<ViewEnquire />} />
            <Route path="/Addservices" element={<AddServices />} />
            <Route path="/service-details/:serviceId" element={<ServiceDetails />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookie" element={<Cookie />} />

          </Routes>
        </main>
        {!shouldHideFooter && <Footer />}
      </div>
    </AnimatePresence>
  );
}

export default App;
